module.exports = __webpack_public_path__ + "img/middle_19.082cb8d2.png";